const navigation = {
    trigger: $('.js-trigger-navigation'),
    elem: $('.js-header-navigation'),
    overlay: true,
    active: false,
    callback: {
        show: function() {
            const triggerWidth = $('.js-trigger-navigation').outerWidth(true);

            $('.js-header-navigation-list').css('width', triggerWidth);
        }
    }
}

const language = {
    trigger: $('.js-trigger-language'),
    elem: $('.js-header-language'),
    overlay: true,
    active: false,
    callback: false
}

const account = {
    trigger: $('.js-trigger-account'),
    elem: $('.js-header-account'),
    overlay: true,
    active: false,
    callback: false
}

const search = {
    trigger: $('.js-trigger-search'),
    elem: $('.js-header-search'),
    overlay: true,
    active: false,
    callback: {
        show: function() {
            $('.js-header-search').find('input[name="search"]').focus();
        }
    }
}

let activeElement;

function toggleElem(object) {
    if (object.active) {
        hideElem(object);
    } else {
        showElem(object);
    }
}

function showElem(object) {
    if (activeElement) {
        hideElem(activeElement);
    }

    object.trigger.addClass('is-active');
    object.elem.addClass('is-active');

    if (object.overlay) {
        showOverlay();
    }

    if (object.callback && object.callback.show) {
        object.callback.show();
    }

    object.active = true;

    activeElement = object;
}

function hideElem(object) {
    object.trigger.removeClass('is-active');
    object.elem.removeClass('is-active');

    if (object.overlay) {
        hideOverlay();
    }

    if (object.callback && object.callback.hide) {
        object.callback.hide();
    }

    object.active = false;
}

function toggleAsideNav(show) {
    if (show) {
        $('.js-aside-nav').addClass('is-active');
        freezeScroll(true);
        showFullscreenOverlay();
    } else {
        $('.js-aside-nav').removeClass('is-active');
        freezeScroll();
        hideFullscreenOverlay();
    }
}

$(function() {
    // * search on enter
    $('body').on('keypress', '.header-search .c-form__input', function(event) {
        if (event.which === 13) {
            const url = '/vyhladavanie?search=' + $(this).val();

            window.location.href = url;
        }
    });

    // * togglers hide
    $('body').on('click', function (event) {
        if (activeElement && activeElement.active) {
            if (!$(event.target).closest(activeElement.elem).length && !$(event.target).closest(activeElement.trigger).length) {
                hideElem(activeElement);
            }
        }

        if ($('.js-aside-nav').hasClass('is-active') && checkMedia('cxs,xs') && !$(event.target).closest('.js-aside-nav').length && !$(event.target).closest('.js-trigger-navigation').length) {
            toggleAsideNav();
        }
    });

    // * languages
    language.trigger.on('click', function() {
        toggleElem(language);
    });

    // * search
    search.trigger.on('click', function() {
        toggleElem(search);
    });

    // * account
    account.trigger.on('click', function() {
        toggleElem(account);
    });

    $('.js-header-account').find('[data-toggle="modal"]').on('click', function() {
        hideElem(account);
    });

    // * navigation && aside
    navigation.trigger.on('click', function() {
        if (checkMedia('cxs,xs')) {
            toggleAsideNav(true);
        } else {
            toggleElem(navigation);
        }
    });

    $('.js-close-navigation').on('click', function() {
        hideElem(navigation);
    });

    $('.js-header-navigation-list').menuAim({
        activate: activateSubmenu,
        deactivate: deactivateSubmenu,
        rowSelector: ".js-header-nav-item"
    });

    function activateSubmenu(row) {
        var $this = $(row),
            activeId = $this.data('id'),
            $activeSub = $('.js-header-subnav[data-id="' + activeId + '"]');

        $('.js-header-nav-item.is-active').removeClass('is-active');
        $('.js-header-subnav.is-active').removeClass('is-active');
        $this.addClass('is-active');
        $activeSub.addClass('is-active');
    }

    function deactivateSubmenu(row) {
        var $this = $(row),
        activeId = $this.data('id'),
        $activeSub = $('.js-header-subnav[data-id="' + activeId + '"]');

        $this.removeClass('is-active');
        $activeSub.removeClass('is-active');
    }

    // * aside
    $('.js-aside-close').on('click', function() {
        toggleAsideNav();
    });

    $('.aside--subnav__back').on('click', function(event) {
        event.preventDefault();

        $(this).parents('.aside__content').toggleClass('away');
        $(this).siblings('.aside--subnav').toggleClass('active');
        $(this).parents('.aside--subnav').toggleClass('active');
    });

    $('.js-aside-nav-sub-trigger').on('click', function(event) {
        event.preventDefault();

        $(this).parents('.aside__content').toggleClass('away');
        $(this).parent().siblings('.aside--subnav').toggleClass('active');
        $(this).parents('.aside--subnav').toggleClass('active');
    });

    // * registration
    $('.js-registration-login-trigger').on('click', function(e) {
        e.preventDefault();

        $('#login-modal').modal('hide');
        $('#login-modal').one('hidden.bs.modal', function() {
            $('#registration').modal('show');
        });
    });

    $('.js-registration-form').validate({
        rules: {
            ico: {
                minlength: 8
            }
        },
        errorPlacement: function(error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.parent());
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            let $form = $(form);

            $form.find('[type="submit"]').prop('disabled', true);
            $('.js-registration-error').slideUp(100);
            $('.js-registration-success').slideUp(100);

            Form.ajaxPost(form, function(data) {
                $form.find('[type="submit"]').prop('disabled', false);

                if (!data.status) {
                    $('.js-registration-error')
                        .text(data.msg)
                        .slideDown(200);
                } else {
                    $('.js-registration-success')
                        .text(data.msg)
                        .slideDown(200);
                        $('.js-registration-hide').slideUp(200);
                }
            }, "json");

            return false;
        }
    });

    // * breadcrbum rcrumbs
    if ($('.js-header-breadcrumb').length) {
        $('.js-header-breadcrumb').rcrumbs({
            nbFixedCrumbs: 1,
            nbUncollapsableCrumbs: 1,
            animation: {
                activated: false
            }
        });
    }
});